/**
 * Shared Recharts prop bundles — import instead of inline hex.
 */
import {
  CHART_AXIS,
  CHART_NEUTRALS,
  CHART_RAMP,
  CHART_TOOLTIP_LABEL_STYLE,
  CHART_TOOLTIP_STYLE,
  chartColor,
} from './tokens';

export {
  CHART_AXIS,
  CHART_NEUTRALS,
  CHART_RAMP,
  CHART_TOOLTIP_LABEL_STYLE,
  CHART_TOOLTIP_STYLE,
  chartColor,
};

export const rechartsGrid = CHART_AXIS.grid;
export const rechartsXAxis = {
  tick: CHART_AXIS.tick,
  axisLine: CHART_AXIS.axisLine,
  tickLine: false,
};
export const rechartsYAxis = {
  tick: CHART_AXIS.tickFigure,
  axisLine: CHART_AXIS.axisLine,
  tickLine: false,
};
export const rechartsTooltip = {
  contentStyle: CHART_TOOLTIP_STYLE,
  labelStyle: CHART_TOOLTIP_LABEL_STYLE,
};
